import store from './index'

import { Snack } from '@/interfaces/snack'
import { User } from '@/interfaces/user'
import { PageMsgInterface } from '@/interfaces/page'
import { IfNewOrders } from '../interfaces/ifNewOrders'

export const dispatchShowSnack = (msg: Snack) => {
  return store.dispatch('snacks/showSnack', msg)
}

export const dispatchSignIn = (me: User) => {
  return store.dispatch('user/signIn', me)
}

export const dispatchSignOut = () => {
  return store.dispatch('user/signOut')
}

// 缓存page
export const dispatchStorePage = (page: PageMsgInterface) => {
  return store.dispatch('page/storePage', page)
}

export const dispatchClearPage = (routeName: string) => {
  return store.dispatch('page/clearPage', routeName)
}

export const dispatchUpdateIfNewOrders = (obj: IfNewOrders) => {
  return store.dispatch('snacks/updateIfNewOrders', obj)
}
